import React, { useMemo } from "react";
import {
  backToHome,
  errorLabel,
  paymentFail,
  paymentProcessingUpdate,
  paymentProcessingUpdateSubMsg,
  redemptionFail,
  redemptionFailSubMessage,
  unableToProcess,
} from "./messages";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { Box, Drawer } from "@mui/material";
import Text from "./text/Text";
import CustomDivider from "./divider/Divider";
import Button from "./button/Button";
import Clipboard from "./clipboard/Clipboard";
import { errorIcons } from "./images";
import { isTMA } from "./constants";

const PaymentFailModal = ({
  isPaymentFailed,
  isNodeRestricted,
  isPaymentProcessing,
  isRedemptionFail,
  isFromBrowser,
  paymentFailedMsg,
  setIsSendModalOpen,
  isShowErrorModal,
  setIsShowErrorModal,
  errorResponse,
  handleModalClose,
}) => {
  const navigate = useNavigate();
  const displayIcon = useMemo(() => {
    if (isPaymentProcessing) {
      return "timer";
    } else {
      return "fail";
    }
  }, [isPaymentFailed, isPaymentProcessing, isRedemptionFail]);

  const headingMsg = () => {
    if (isPaymentFailed) {
      return isNodeRestricted ? unableToProcess : paymentFail;
    } else if (isPaymentProcessing) {
      return paymentProcessingUpdate;
    } else {
      return redemptionFail;
    }
  };

  const subMessage = () => {
    if (isPaymentFailed) {
      return paymentFailedMsg;
    } else if (isPaymentProcessing) {
      return paymentProcessingUpdateSubMsg;
    } else {
      return redemptionFailSubMessage;
    }
  };

  const handleBackToHome = () => {
    setIsShowErrorModal(false);
    setIsSendModalOpen(false);
    navigate("/close-modal");
  };

  const showAdditionalSection = () => {
    return (
      <Box className="error-section">
        <Box
          borderBottom="1px solid #F6F3F3"
          display="flex"
          justifyContent="space-between"
          pb="16px"
          mb="16px"
        >
          <Text className="default-text" size={16} font="semibold">
            {errorLabel}
          </Text>
          <Clipboard text={errorResponse} height="18px" width="18px" />
        </Box>
        <Text className="grey-text" size={14} font="regular">
          {errorResponse}
        </Text>
      </Box>
    );
  };

  return (
    <Drawer
      anchor="bottom"
      open={isShowErrorModal}
      onClose={handleModalClose}
      className="payment-failed-modal"
      PaperProps={{
        sx: {
          borderTopLeftRadius: "14px",
          borderTopRightRadius: "14px",
          margin: "auto",
        },
      }}
      ModalProps={{
        disablePortal: !isTMA(),
      }}
      sx={{ zIndex: 1300 }}
    >
      <Box className={isFromBrowser ? "error-modal-wrapper-options" : ""}>
        <Box className="error-modal-container">
          <Box> {errorIcons[displayIcon]}</Box>
          <Text
            className="default-text"
            size={20}
            font="semibold"
            sx={{ marginTop: "8px" }}
          >
            {headingMsg()}
          </Text>
          <Text
            className="grey-text"
            size={isFromBrowser ? 16 : 14}
            font="regular"
            variant="body1"
            sx={{ marginTop: "10px", wordBreak: "break-word" }}
          >
            {subMessage()}
          </Text>
          <CustomDivider
            sx={{ margin: "16px 0", padding: "0 20px", width: "100%" }}
          />
          {isRedemptionFail ? (
            showAdditionalSection()
          ) : (
            <Button
              fullWidth
              variant="outlined"
              label={backToHome}
              onClick={() => {
                handleBackToHome();
              }}
            />
          )}
        </Box>
      </Box>
    </Drawer>
  );
};

export default PaymentFailModal;
